import { createSlice } from "@reduxjs/toolkit";

export type RumState = {
  videoInfoPageStartTimeStamp: number;
  additionalInfoPageStartTimeStamp: number;
};

const initialState: RumState = {
  videoInfoPageStartTimeStamp: 0,
  additionalInfoPageStartTimeStamp: 0,
};

/** Rum Slice */
const { reducer, actions } = createSlice({
  name: "rumSlice",
  initialState,
  reducers: {
    setVideoInfoPageStartTimeStamp: (state, { payload }) => {
      state.videoInfoPageStartTimeStamp = payload;
    },
    setAdditionalInfoPageStartTimeStamp: (state, { payload }) => {
      state.additionalInfoPageStartTimeStamp = payload;
    },
  },
});

export const {
  setVideoInfoPageStartTimeStamp,
  setAdditionalInfoPageStartTimeStamp,
} = actions;

export default reducer;
